// predictive-search.js

document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.querySelector("#search-input"); // Your search input ID
  const resultsContainer = document.createElement("ul");
  resultsContainer.classList.add("predictive-results");
  searchInput.parentNode.appendChild(resultsContainer);

  let debounceTimeout;

  searchInput.addEventListener("input", function () {
    const query = searchInput.value.trim();

    // Clear previous timeout
    clearTimeout(debounceTimeout);

    // Only search if query length > 2
    if (query.length > 2) {
      debounceTimeout = setTimeout(() => {
        fetchSuggestions(query);
      }, 300); // Debounce to reduce API calls
    } else {
      resultsContainer.innerHTML = ""; // Clear results
    }
  });

  async function fetchSuggestions(query) {
    try {
      // Shopify predictive search endpoint
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`
      );
      const data = await response.json();
      displayResults(data.resources.results.products);
    } catch (error) {
      console.error("Predictive search error:", error);
      resultsContainer.innerHTML = "<li>Error loading results</li>";
    }
  }

  function displayResults(products) {
    resultsContainer.innerHTML = ""; // Clear previous results
    if (products.length === 0) {
      resultsContainer.innerHTML = "<li>No results found</li>";
      return;
    }

    products.forEach((product) => {
      const li = document.createElement("li");
      li.innerHTML = `<a href="${product.url}">${product.title}</a>`;
      resultsContainer.appendChild(li);
    });
  }
});
